<template>
  <PublicHeader />
    <div class="container login sm-pdt-100 justify-content-center">
        <div class="w-100 d-flex justify-content-center align-items-center gap-20">
            <!-- Form Column -->
            <div class="w-100 d-flex flex-column justify-content-center">
                <div v-if="!showVerification">
                    <form @submit.prevent="submitForm" class="gap-10 form-two-factor-setup">
                        <div class="mb-20" v-if="legacy == 1">
                            <h2>Reset Password</h2>
                            <p>To ensure your account's security, please update your password to meet our new platform's enhanced security standards. Legacy passwords are no longer supported. Your new password must include a mix of letters, numbers, and special characters for better protection.</p>
                            <TextInput
                            type="password"
                            name="mixed"
                            placeholder="Password"
                            v-model="password"
                            class="mt-20"
                            />
                            <ul v-if="errors.password" class="text-danger pdl-15">
                                <li v-for="(err, index) in errors.password" :key="index">{{ err }}</li>
                            </ul>
                            <TextInput
                            type="password"
                            name="mixed"
                            placeholder="Password Confirmation"
                            v-model="passwordConfirmation"
                            class="mt-20"
                            />
                        </div>
                        <h2>2 Factor Authentication</h2>
                        <label for="radioGroup">We will send a code to your preferred method</label>
                        <p class="fs-sm text-dark-grey">Please use a personal mobile phone number or email that you have sole control over for your 2FA.  We will record your entry and you will need to access this to retrieve your authentication code whenever you login. </p>

                        <h5 class="pdt-10">Preferred Method</h5>
                        <div class="radio-buttons d-flex mt-15">
                            <div class="d-flex gap-2">
                                <input
                                    type="radio"
                                    id="participant"
                                    name="method"
                                    value="P"
                                    v-model="method"
                                    />
                                <label for="participant">Phone number</label>
                            </div>
                            <div class="d-flex gap-2 pdl-30">
                                <input
                                    type="radio"
                                    id="local"
                                    name="method"
                                    value="E"
                                    v-model="method"
                                    />
                                <label for="local">Email Address</label>
                            </div>
                        </div>
                        <!-- <p>Mobile service unavailable.  Please setup 2FA with email.</p> -->
                        <ul v-if="errors.method" class="text-danger pdl-15">
                            <li v-for="(err, index) in errors.method" :key="index">{{ err }}</li>
                        </ul>
                        <!-- Phone Input Field -->
                        <div v-if="method === 'P'" class="w-100 mt-3">
                            <label for="phone">Phone Number</label>
                            <PhoneField type="tel" label="Verified Phone number" placeholder="x (xxx) xxx-xxxx" :max=17 v-model="phone" />
                            <small class="info_card info_card__danger mt-10">By selecting the Phone Number option, providing us your mobile phone number, and clicking “Send Code,” you hereby consent to receive a verification message by text to the mobile phone number provided to register, as well as any time you wish to log in in order to verify your identity.</small>
                        </div>
                        <div v-if="method === 'E'" class="w-100 mt-3">
                            <label for="phone">Email Address</label>
                          <TextInput  type="email" v-model:modelValue="email" label="Verified Email Address" placeholder='Enter Email' :error="generalErrors" :max=100 />
                          <small class="info_card info_card__danger mt-10">By selecting the Email Address option, providing us your email address, and clicking “Send Code,” you hereby consent to receive a verification message by email to the email address provided to register, as well as any time you wish to log in in order to verify your identity.</small>
                        </div>
                        <div class="d-flex gap-4 mt-4 ms-md-0 ms-auto">
                            <button type="submit" class="btn btn-primary">Send Code</button>
                        </div>
                        <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
                    </form>
                </div>
                <div v-else>
                    <h2>Enter Verification Code</h2>
                    <div class="form-group d-flex flex-column gap-4 mb-4">
                        <label for="code">Enter the code sent to your {{ method === 'P' ? 'phone number' : 'email address' }}</label>
                        <VerificationCodeInput v-model="code" @keyup.enter="verifyCode"/>
                        <div class="d-flex gap-4 mt-4">
                           <button type="button" @click="backToSetup" class="btn btn-secondary">Go Back / Change 2FA  {{method === 'P' ? 'Number' :  'Email'}}</button>
                            <button @click="verifyCode" class="btn btn-primary">Verify Code</button>
                        </div>
                        <div class="mt-3">
                            <a href="#" @click.prevent="submitForm">Resend Code</a>
                            <span v-if="timer > 0"> ({{ timer }} seconds remaining)</span>
                        </div>
                        <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
                    </div>
                </div>
            </div>
            <!-- Image Column -->
            <div class="w-100 hide-mobile">
              <img style="max-width: 100%; max-height: 90vh;" class="rounded img-fluid" src="@/assets/images/2fa-picture.jpg" alt="2FA Image" />
            </div>
        </div>
    </div>
  <PublicFooter />
</template>

  <script lang="ts">
  import { ref, computed, onUnmounted, onMounted, watch } from 'vue';
  import axios from 'axios';
  import { useAuthStore } from '@/stores/auth';
  import { useModalStore } from '@/stores/modal';
  import { useRouter, useRoute } from 'vue-router';
  import VerificationCodeInput from '@components/form/VerificationCodeField.vue';
  import PhoneField from '@components/form/PhoneField.vue';
  import TextInput from '@components/form/TextInput.vue';
  import PublicFooter from '@/components/PublicFooter.vue';
  import PublicHeader from '@/components/PublicHeader.vue';
  import UpdateEmailTwoFA from '@/components/UpdateEmailTwoFA.vue';
  import { useParticipantStore } from '@/stores/participant';

  export default {
    components: {
        VerificationCodeInput,
        PhoneField,
        TextInput,
        PublicFooter,
        PublicHeader,
        // UpdateEmailTwoFA
    },
    setup() {
      const router = useRouter();
      const route = useRoute();
      const authStore = useAuthStore();
      const modalStore = useModalStore();
      const token = computed(() => route.query.token as string ?? '');

    //   watch(() => token.value, (newToken) => {
    //     authStore.setToken(newToken);
    //   })

      // Legacy
      const password = ref('');
      const passwordConfirmation = ref('');
      const defaultTime = 360;

      const method = ref('');
      const phone = ref(useParticipantStore().userPhone);
      const email = ref(useParticipantStore().userEmail);
      const code = ref('');
      const showVerification = ref(false);
      const expirationTime = ref(360);
      const timer = ref(0);
      const timerInterval = ref<number | null>(null);
      const errorMessage = ref('');
      const generalErrors = ref('');
      const errors = ref<Record<string, string[]>>({});
      const legacy = route.query.legacy || route.params.legacy;
      const showChangeEmail = computed(() => false)

      const startTimer = () => {
        timer.value = expirationTime.value;
        if (timerInterval.value) {
          clearInterval(timerInterval.value);
        }
        timerInterval.value = setInterval(() => {
          if (timer.value > 0) {
            timer.value--;
          } else {
            clearInterval(timerInterval.value!);
            timerInterval.value = null;
          }
        }, 1000);
      };

      const submitForm = async () => {
        generalErrors.value = '';

          try {
              const payload: Record<string, any> = { method: method.value };
              if (method.value === 'P') {
                  payload.phone = phone.value;
              }

              if (method.value === 'E') {
                generalErrors.value  = await useParticipantStore().checkUser(email.value ?? '');

                payload.email = email.value;
              }

              // Conditionally add password if legacy flag is set
              if (legacy) {
                  payload.password = password.value;
                  payload.password_confirmation = passwordConfirmation.value;
              }

              if(!generalErrors.value.length) {
                const response = await axios.post('/api/authorization/setup/submit-method', payload);

                if (response.data.success) {
                    showVerification.value = true;
                    // Use expiration time from API if available
                    expirationTime.value = response.data.expirationTime || defaultTime;
                    startTimer();
                    errorMessage.value = '';
                    errors.value = {}; // Clear errors on success
                } else {
                    // Process validation errors from Laravel response
                    if (response.data.validator_errors) {
                        errors.value = response.data.validator_errors;
                    } else {
                        errorMessage.value = response.data.message || 'An error occurred.';
                    }
                }
              }
          } catch (error: any) {
              console.error(error);
              if (error.response?.data?.validator_errors) {
                  // Map validator errors to the errors object
                  errors.value = error.response.data.validator_errors;
              } else {
                  errorMessage.value = error.response?.data?.message || 'An error occurred.';
              }
          }
        };

        const submitEmail = async () => {
          const formData = {
            email: email.value,
          };

          axios.post('api/user/settings', { ...formData, _method: 'PATCH' })
              .then(response => {
                  useModalStore().closeAbove(0);
                  useParticipantStore().getUserEmail();
              })
              .catch((error: any) => {
                  if (error.response) {
                      errors.value = error.response.data.errors;
                  }
              })
      };


      const verifyCode = async () => {
        try {
          const payload = {
            verification_code: code.value,
            password: password.value,
            method: method.value,
          };
          const response = await axios.post('/api/authorization/setup/submit-code', payload);
          if (response.data.success) {
            // Verification successful
            // Redirect or perform necessary actions
            await submitEmail();
            authStore.set2FaValidated(true);
            // router.push({ name: authStore.getDashboardRoute });
            router.push({ name: 'terms' });
          } else {
            // Handle error
            errorMessage.value = response.data.message || 'Invalid verification code.';
            code.value = '';
          }
        }
        catch (error: any) {
            if (error.response && error.response.data) {
                // Capture API errors
                errorMessage.value = error.response.data.error || 'An error occurred';
            }
            else {
                errorMessage.value = 'Unexpected error occurred';
            }
            code.value = '';
        }
      };

      const backToSetup = (type: string) => {
        showVerification.value = false;
      }

      const resendCode = async () => {
        try {
          const payload: Record<string, any> = { method: method.value };
          if (method.value === 'P') {
            payload.phone = phone.value;
          }

          const response = await axios.post('/api/authorization/setup/resend-code', payload);

          if (response.data.success) {
            // Use new expiration time if provided
            if (response.data.expirationTime) {
              expirationTime.value = response.data.expirationTime;
            } else {
              expirationTime.value = defaultTime;
            }

            errorMessage.value = '';
            startTimer();
          }
          else {
            // Handle error
            errorMessage.value = response.data.message || 'An error occurred while resending the code.';
          }
        }
        catch (error: any) {
          console.error(error);
          errorMessage.value = error.response?.data?.message || 'An error occurred.';
        }
      };

      // Clean up the timer when the component is unmounted
      onUnmounted(() => {
        if (timerInterval.value) {
          clearInterval(timerInterval.value);
        }
      });

      onMounted(async()=> {
        await useParticipantStore().getUserEmail();
        email.value = useParticipantStore().userEmail;
        phone.value = useParticipantStore().userPhone;
      })

      return {
        backToSetup,
        generalErrors,
        legacy,
        password,
        passwordConfirmation,
        method,
        phone,
        code,
        showVerification,
        expirationTime,
        timer,
        showChangeEmail,
        submitForm,
        verifyCode,
        resendCode,
        errorMessage,
        errors,
        email
      };
    },
  };
  </script>